import { render, staticRenderFns } from "./SuspendRoleModal.vue?vue&type=template&id=2ad3e5ea"
import script from "./SuspendRoleModal.vue?vue&type=script&lang=js"
export * from "./SuspendRoleModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports